<style scoped>
.recentlyClosed{
	box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
.opened{
	box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
/*.enabled-bidders{
	float: right;
}*/
.enabled-bidders p{
	display: inline;
    background: #8b85e5;
    margin: 0 5px;
    padding: 2px;
    border-radius: 3px;
    color: #18171a;
}
/*.el-collapse-item__header{
	height: auto !important;
}*/
.heading-cart{
	border-top: none;
}
.box-body{
	padding: 0px 30px !important;
}
</style>
<template>
	<div class="content-wrapper">
		<section class="content">
			<div class="box" >
				<div class="box-header with-border">
					<h3 class="box-title">{{ message }}</h3>
				</div>
				<div class="box-body" v-loading="loading">
					<div class="box-header with-border">

						<el-dialog
							class = "element-promt"
							title="Select HB tags"
							:visible.sync="dialogVisible"
							width="40%"
							:before-close="handleClose">
							<!-- <el-input type="textarea" :rows="10" v-model = "metaCopy"></el-input> -->
							<!-- <p v-for="hb_tag in hb_tags">
								<span v-if="hb_tag.publisher_dfp_unit">{{ `${domain_details.dfp_network.network_code}/${hb_tag.dfp_ad_unit_code}` }}</span>
								<span v-else>{{ `${domain_details.dfp_network.network_code}/${hb_tag.dfp_parent_ad_unit_path}/${hb_tag.dfp_ad_unit_code}` }}</span>
							</p> -->
							<el-button @click="selectAll">Select all</el-button>

							<div style="padding: 20px 0px;">
								<el-checkbox style="width: 50%;margin: 10px 0px;" v-for="hb_tag in hb_tags" :value="hb_tag.id" name="hb_tag[]" :id="`${hb_tag.id}`" v-model="hb_tag['checked']" @change="checkedHbtag" v-if="filterHbtag(hb_tag)">
									<!-- <label :for="`${hb_tag.id}`"> -->
										<span v-if="hb_tag.publisher_dfp_unit">{{ `${domain_details.dfp_network.network_code}/${hb_tag.dfp_ad_unit_code}` }}</span>
										<span v-else>{{ `${domain_details.dfp_network.network_code}/${hb_tag.dfp_parent_ad_unit_path}/${hb_tag.dfp_ad_unit_code}` }}</span>
									<!-- </label> -->
								</el-checkbox>
							</div>

							<span slot="footer" class="dialog-footer">
								<el-button @click="closeDialog">Cancel</el-button>
								<el-button type="primary" @click="updateHbTag(updatingDimen)">Apply</el-button>
							</span>
						</el-dialog>

						<div class="heading-cart">
							<el-collapse v-model="activeNames" accordion>
								<el-collapse-item style="margin-bottom: 10px;" v-bind:class="{ recentlyClosed: (recentlyClosed == dimension.id), opened: (activeNames == dimension.id)}" v-for="dimension in dimensionWiseParams" :title="getDimensionInStr(dimension.id)" :name="dimension.id" class="collapse--item">
									<template slot="title" style="height: auto;">
										<div style="width: 10%;display: inline-block;position: relative;">
											<h4 style="line-height: 47px; margin: 0px;padding: 0px 10px;">
												{{ getDimensionInStr(dimension.id) }}
											</h4>
										</div>
										
										<div style="width: 85%;display: inline-block;position: relative;">
											<div class="enabled-bidders">
												<p v-for="bidder in getEnabledBidders(dimension.id)">
													{{ bidder }}
												</p>
												<p style="color: red;" v-show="getEnabledBidders(dimension.id).length == 0">
													No bidders enabled
												</p>
											</div>
										</div>
										
									</template>
									<div>									
										
										<div v-for="bidder in allBidders">
											<div class="col-md-12 m-b-10 m-t-10">
												<el-checkbox :value="bidder.id" name="bidder[]" :id="bidder.code + '_' + dimension.id" v-model="bidderParamsForm[dimension.id][bidder.code]['enabled']">
													<label :for="bidder.code">{{ bidder.name }}</label>
												</el-checkbox>

												<div class="row" v-show="bidderParamsForm[dimension.id][bidder.code]['enabled']">
													<div v-for="field in getBidderFields(bidder.id)" class="col-md-4">
														<div v-if="field.type=='text'" class="form-group">
															<div v-if="bidderParamsForm[dimension.id][bidder.code]">
																<p :for="field.label" class="bold pull-left">{{ field.label }}</p>
																<input v-model="bidderParamsForm[dimension.id][bidder.code][field.name]" type="text" :id="field.label" class="form-control" :required="bidderParamsForm[dimension.id][bidder.code]['enabled']"/>
															</div>
														</div>


														<div v-if="field.type=='number'" class="form-group">
															<div v-if="bidderParamsForm[dimension.id][bidder.code]">
																<p :for="field.label" class="bold pull-left">{{ field.label }}</p>
																<input v-model.number="bidderParamsForm[dimension.id][bidder.code][field.name]" type="number" id="[[ field.label ]]" class="form-control" step="0.01"/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

									</div>
									<el-button type="primary" class="col-md-2" style="float:left;margin:20px;" @click="updateHbTagDiag(dimension)">
										Apply
									</el-button>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		data() {
			return {
				dialogVisible: false,
				message: 'Input HB tag params dimension wise!',
				domId: undefined,
				dimensions: [],
				allBidders: [],
				activeNames: undefined,
				dimensionWiseParams: undefined,
				bidderParamsForm: {},
				loading: true,
				hb_tags: [],
				hb_tag_ids: [],
				pubUid: undefined,
				domain_details: undefined,
				updatingDimen: undefined
			};
		},
		created: function(){
			this.initialize();
		},
		methods: {
			initialize(){
				this.domId = this.$route.params.domId;
				this.pubUid = this.$route.params.uuid;
				axios.all([
					axios.get(BASE_URL + 'v1/ad-dimensions/'),
					axios.get(BASE_URL + 'v1/get-bidders-under-domain/' + this.domId),
					axios.get(BASE_URL + 'v1/hb_tags_dimensions/' + this.domId + '/'),
					axios.get(BASE_URL +'v1/hb_tags/'+ this.domId + '/'),
					axios.get(BASE_URL + `v1/publishers/${this.pubUid}/domains/${this.domId}/`),
				])
				.then(axios.spread((dimensions, bidders, params, hb_tags, domain) =>  {
					console.log(dimensions);
					console.log(bidders);
					console.log(params);
					this.dimensionWiseParams = params['data']['response_data']['hb_params'];
					this.dimensions = dimensions.data;
					this.allBidders = bidders.data;
					this.hb_tags = hb_tags.data.response_data.hb_tags;
					// this.hb_tags.forEach((hb_tag) => {
					// 	hb_tag.checked = true
					// });

					this.domain_details = domain.data;

					this.dimensionWiseParams.forEach((dimen) => {
						console.log(dimen.id);
						this.bidderParamsForm[dimen.id] = {};
						for (var bidder in dimen.params) {
							this.bidderParamsForm[dimen.id][bidder] = dimen.params[bidder];
						}
					});
					this.loading = false;
				}));
			},
			getDimensionInStr(id){
				let dimension = this.dimensions.filter((dimen) => {
					return dimen['id'] == id;
				})[0];
				return `${dimension.width}X${dimension.height}`;
			},
			getBidderFields(bidder_id) {
				for(let i = 0;i < this.allBidders.length; i++){
					if(this.allBidders[i].id == bidder_id){
						return JSON.parse(this.allBidders[i].param);
					}
				}
			},
			getEnabledBidders(dimension_id){
				let bidders = [];
				for (var bidder in this.bidderParamsForm[dimension_id]) {
					if(this.bidderParamsForm[dimension_id][bidder]['enabled']){
						bidders.push(bidder);
					}
				}
				return bidders;
				// this.bidderParamsForm[dimension_id].map((param) => {

				// })
			},
			handleClose(){

			},
			closeDialog(){
				this.dialogVisible = false;
				this.updatingDimen = undefined;
			},
			checkedHbtag(val){
				console.log(val);
				this.$forceUpdate();
			},
			CheckChanged(dimension_id){
				if(!this.hb_tag_ids.includes(dimension_id)) this.hb_tag_ids.push(dimension_id)
				else{
					let index = this.hb_tag_ids.indexOf(dimension_id);
					this.hb_tag_ids.splice(index, 1);
				}
			},
			Check(dimension_id){
				return this.hb_tag_ids.includes(dimension_id);
			},
			updateHbTagDiag(dimension){
				console.log('updateHbTagDiag');
				// this.hb_tags.forEach((hb_tag) => {
				// 	hb_tag.checked = true
				// });
				this.dialogVisible = true;
				this.updatingDimen = dimension;
				this.deselectAll();
			},
			selectAll(){
				this.hb_tags.forEach((hb_tag) => {
					let dim_found = hb_tag.dimensions.find((dimension) => {
						return dimension.id == this.updatingDimen.id;
					});
					if(dim_found) hb_tag.checked = true;
				});
				this.$forceUpdate();
			},
			deselectAll(){
				this.hb_tags.forEach((hb_tag) => {
					hb_tag.checked = false;
				});
				this.$forceUpdate();
			},
			filterHbtag(tag){
				if(this.updatingDimen){
					let res = tag.dimensions.filter((dimension) => {
						return this.updatingDimen.id == dimension.id;
					});
					if(res.length>0) return true;
					else return false;
				}
			},
			updateHbTag(dimension){
				this.hb_tag_ids = this.hb_tags.filter((hb_tag) => {
					return hb_tag.checked;
				});
				this.hb_tag_ids = this.hb_tag_ids.map((hb_tag) => {
					return hb_tag.id;
				});
				// console.log(hb_tag_ids); //??
				console.log(this.hb_tag_ids);

				console.log(this.bidderParamsForm[dimension.id]);
				let tempParams = JSON.parse(JSON.stringify(this.bidderParamsForm[dimension.id]));

				for (var bidders in tempParams) {
					console.log(bidders);
					for (var params in tempParams[bidders]){
						// console.log(tempParams[bidders][params]);
						if(tempParams[bidders][params].toString().trim() == '') delete tempParams[bidders][params];
					}
				}
				console.log(tempParams);

				let requestObject = {
					'bidders': JSON.stringify(tempParams),
					'dimensionId': dimension.id,
					'hb_tag_ids': this.hb_tag_ids
				}

				axios.post(BASE_URL +'v1/update_hb_tag_dimension_wise/'+ this.domId + '/', requestObject)
				.then(response => {
					console.log(response);
					if(response.data.status == 'success'){
						this.$notify({
							title: 'Success',
							message: 'Successfully updated the tag!!',
							type: 'success'
						});
						this.recentlyClosed = response.data.dimensionId;
						this.activeNames = '';
						this.dialogVisible = false
					}
					else if(response.data.status == 'error'){
						this.$notify({
							title: 'Error',
							message: response.data.reason,
							type: 'error'
						});
						this.recentlyClosed = response.data.dimensionId;
						this.activeNames = '';
					}
					// this.$emit('update_logs')
					// console.log(EventBus);
					// EventBus.$emit('update_logs')
				})
				.catch(function (error) {
					console.log('Error:', error);
				});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// HbTagDimensionParams.vue?f5bced7a